// Typelizer digest c41525e7438adfaaf5511dc61512ab91
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../../runtime'
import { buildUrl } from '../../../runtime'

export default {
  /** GET /c/:company_id/ledger/review_queue/payments/:id */
  show: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/c/:company_id/ledger/review_queue/payments/:id', params, options),
    method: 'get',
  }),
}
